import React from "react";
import CompanyReportSection from "shared/reports/components/companyReportSection/CompanyReportSection";
import ReportsCollectionWrapper from "shared/reports/components/reportsCollectionWrapper/ReportsCollectionWrapper";
import GroupLevelRanking from "../groupLevelRanking/GroupLevelRanking";
import { RankingReportElement } from "motivationCard/service/api/models";

interface CompanyRankingReportSectionProps {
    companyName?: string;
    reports: RankingReportElement[];
    additionalClassName?: string;
}

const CompanyRankingReportSection: React.FC<CompanyRankingReportSectionProps> = (
    props: CompanyRankingReportSectionProps
) => {
    const renderReportElementRank = (report: RankingReportElement) => {
        return (
            <div style={{ flexGrow: 1 }} key={`${report.salesNetworkType}${report.group}`}>
                <GroupLevelRanking
                    change={report.positionDelta ?? 0}
                    rank={report.position ?? 0}
                    numberOfCompetitors={report.groupCount}
                    planTarget={report.planTarget}
                    planValue={report.planValue}
                    unit={report.unitType}
                />
            </div>
        );
    };

    const getReportElementTitle = (report: RankingReportElement) => {
        return report.title;
    };

    const getReportElementText = (report: RankingReportElement) => {
        return report.text;
    };

    const getReportContents = () => {
        if (!props.reports) {
            return null;
        }

        return (
            <ReportsCollectionWrapper
                reports={props.reports}
                reportElementTitle={getReportElementTitle}
                reportElementText={getReportElementText}
                renderReportElement={renderReportElementRank}
            />
        );
    };

    return (
        <CompanyReportSection
            companyName={props.companyName}
            reportContents={getReportContents()}
            additionalClassName={props.additionalClassName}
        />
    );
};

export default CompanyRankingReportSection;
